const SongListDatabase = {
    "aba_ginoong_maria": "Aba Ginoong Maria",
    "adeste_fideles": "Adeste Fideles",
    "alay_sa_diyos": "Alay sa Diyos",
    "alleluia": "Alleluia",
    "ama_namin": "Ama Namin",
    "ama_namin_v2": "Ama Namin",
    "amami_ilocano": "Amami",
    "amami_ilocano_v2": "Amami v2",
    "amazing_grace": "Amazing Grace",
    "ang_pasko_ay_sumapit": "Ang Pasko ay Sumapit",
    "anima_christi": "Anima Christi",
    "babaen_ti_krusmo": "Babaen Ti Krusmo",
    "balang_araw": "Balang Araw",
    "bayan_umawit": "Bayan, Umawit",
    "be_not_afraid": "Be Not Afraid",
    "be_still_my_soul": "Be Still, My Soul",
    "blessed_be_god": "Blessed are You Lord God of All Creation",
    "christ_the_lord_is_risen_today": "Christ the Lord Is Risen Today",
    "christify": "Christify",
    "cordero_ti_dios_ilocano": "Cordero ti Dios",
    "create_in_me": "Create In Me",
    "doxology_to_the_our_father": "Doxology to the Our Father",
    "emmanuel_isang_dalagay_maglilihi": "Emmanuel (Isang Dalaga'y Maglilihi)",
    "gather_the_people": "Gather The People",
    "gloria_ilocano": "Gloria iti Dios iti kangatoan",
    "gloria_ilocano_v2": "Gloria (Ilocano)",
    "gloria_ilocano_v3": "Gloria (Ilocano)",
    "gloria_in_excelsis_deo": "Gloria In Excelsis Deo",
    "glory_and_praise_to_our_god": "Glory and Praise To Our God",
    "glory_to_god_light_from_light": "Glory to God (Light from Light)",
    "glory_to_god_mass_of_light": "Glory to God (Mass of Light)",
    "good_christian_men_rejoice": "Good Christian Men Rejoice",
    "great_amen_wyd_95": "Great Amen WYD '95'",
    "great_is_our_god": "Great Is Our God",
    "hail_holy_queen": "Hail Holy Queen Enthroned Above",
    "handog_namin": "Handog Namin",
    "he_is_exalted": "He Is Exalted",
    "here_i_am_lord": "Here I Am, Lord",
    "here_in_this_place": "Here in this place",
    "holy_holy_david_haas": "Holy by David Haas",
    "hosanna_our_king_is_here": "Hosanna! Our King is Here!",
    "hosea": "Hosea",
    "how_lovely_is_your_dwelling_place": "How Lovely Is Your Dwelling Place",
    "humayot_ihayag": "Humayo't Ihayag",
    "i_love_the_lord": "I Love The Lord",
    "i_will_sing_forever": "I Will Sing Forever",
    "idatonmi_kenka_apo": "Idatonmi Kenka Apo",
    "iesu_panis_vitae": "Iesu, Panis Vitae",
    "in_him_alone": "In Him Alone",
    "introit_psalm_100": "Introit (Psalm 100)",
    "joy_to_the_world": "Joy to the World (Eng, Ilc & Tlg)",
    "kordero_ng_diyos": "Kordero Ng Diyos (Cayabyab)",
    "kordero_ng_diyos_francisco": "Kordero Ng Diyos (Francisco)",
    "kyrie_eleison": "Kyrie Eleison (Ilocano)",
    "kyrie_eleison_chorus": "Kyrie Eleison (Chorus)",
    "kyrie_eleison_lfl": "Kyrie Eleison (LFL)",
    "lamb_of_god": "Lamb of God by Manoling Francisco",
    "let_heaven_rejoice": "Let Heaven Rejoice",
    "lord_we_gather_today": "Lord, We Gather Today",
    "mary_immaculate": "Mary Immaculate",
    "miserere": "Miserere",
    "mother_of_christ": "Mother of Christ",
    "naarian_nga_ili": "Naarian Nga Ili",
    "ningas_ng_pagasa": "Ningas ng Pag-asa",
    "now_we_remain": "Now We Remain",
    "o_come_all_ye_faithful": "O Come All Ye Faithful (Adeste & Umaykay)",
    "o_come_o_come_emmanuel": "O Come O Come, Emmanuel",
    "o_god_beyond_all_praising": "O God Beyond All Praising",
    "o_holy_night": "O Holy Night",
    "o_little_town_of_bethlehem": "O little town of Bethlehem",
    "o_maria_nalibnoska": "O Maria Nalibnoska",
    "o_sacrament_most_holy": "O Sacrament Most Holy",
    "o_salutaris_hostia": "O Salutaris Hostia",
    "o_santa_lucia": "O Santa Lucia",
    "on_eagles_wings": "On Eagle's Wings",
    "on_this_day_the_first_of_days": "On this day, the first of days",
    "one_bread_one_body": "One Bread, One Body",
    "one_thing_i_ask": "One Thing I Ask by Hangad",
    "our_father": "Our Father",
    "pagaalaala": "Pag-aalaala",
    "paghahandog_ng_sarili": "Paghahandog ng Sarili",
    "paghuhugas_ng_paa": "Paghuhugas ng Paa",
    "pagkakaibigan": "Pagkakaibigan",
    "pagsibol": "Pagsibol",
    "pananagutan": "Pananagutan",
    "papuri_sa_diyos": "Papuri Sa Diyos",
    "pilgrims_of_hope": "Pilgrims of Hope",
    "praise_to_you_lord_jesus_christ": "Praise to you Lord Jesus Christ",
    "purihin_ang_panginoon": "Purihin ang Panginoon",
    "regina_caeli": "Regina Caeli",
    "sa_hapag_ng_panginoon": "Sa Hapag ng Panginoon",
    "sa_krus_mo_at_pagkabuhay": "Sa Krus Mo at Pagkabuhay",
    "salve_regina": "Salve Regina",
    "santo_francisco": "Santo by Manoling Francisco",
    "santo_ilocano": "Santo",
    "santo_ilocano_v2": "Santo (v2)",
    "save_us_o_lord": "Save Us, O Lord",
    "save_us_savior_of_the_world": "Save us, Savior of the world",
    "silent_night": "Silent Night",
    "sing_a_new_song": "Sing A New Song",
    "stella_maris": "Stella Maris",
    "ta_kukuam_ti_turay_ilocano": "Ta Kukuam ti Turay, Panakablin, ken Dayaw",
    "tantum_ergo": "Tantum Ergo",
    "tell_the_world_of_his_love": "Tell the World of His Love",
    "the_face_of_god": "The Face of God",
    "the_presence_of_jesus": "The Presence of Jesus",
    "ti_bilinko_agiinayatkayo": "Ti Bilinko Agiinayatkayo",
    "ti_krus_ni_apotayo_a_jesucristo": "Ti Krus ni Apotayo a Jesucristo",
    "ti_nadiosan_nga_ayat": "Ti Nadiosan nga Ayat",
    "tinapay_at_alak_naming_hatid": "Tinapay at Alak Naming Hatid",
    "tinapay_ng_buhay": "Tinapay ng Buhay",
    "tubig_ng_buhay": "Tubig ng Buhay",
    "umayka_hesus": "Umayka Hesus",
    "umayka_umayka_emmanuel": "Umayka, Umayka Emmanuel",
    "veni_sancte_spiritus": "veni sancte spiritus",
    "veni_sancte_spiritus_taize": "Veni Sancte Spiritus (Taize)",
    "way_of_the_cross": "Way of the Cross by Manoling Francisco, SJ",
    "we_remember": "We Remember",
    "we_will_rise": "We Will Rise",
    "what_child_is_this": "What Child Is This?",
    "when_we_eat_this_bread": "When we Eat this Bread by Manoling Francisco, SJ",
    "wika_moy_aming_diringgin": "Wika Mo'y aming diringgin",
    "you_are_mine": "You Are Mine",
    "you_shall_be_clothed_with_power": "You shall be clothed with power",
};

export default SongListDatabase;
